import { Star } from 'lucide-react';
import { motion } from 'framer-motion';

const REVIEW_URL = 'https://www.stackmymap.com/review/df7ef2cc-dea1-4d09-997b-ee9bd9222a4d?t=5';

const fadeIn = { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true } };
const fadeInUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true } };

export default function TestimonialsSection() {
  return (
    <section data-testid="testimonials-section" className="py-24 sm:py-32 px-6 bg-zinc-50 border-t border-zinc-200">
      <div className="max-w-7xl mx-auto text-center">
        <motion.p {...fadeIn} className="font-body text-xs uppercase tracking-[0.2em] text-zinc-400 mb-3">Customer Reviews</motion.p>
        <motion.h2 {...fadeInUp} transition={{ duration: 0.5 }} className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight uppercase mb-4">
          What Our Clients Say
        </motion.h2>
        <motion.p {...fadeInUp} transition={{ duration: 0.5, delay: 0.1 }} className="font-body text-zinc-500 max-w-xl mx-auto mb-10">
          We're proud to maintain a 5.0-star Google rating. Your feedback helps us continue delivering exceptional electrical service to Nashville.
        </motion.p>

        {/* Star display */}
        <motion.div {...fadeInUp} transition={{ duration: 0.5, delay: 0.2 }} className="flex justify-center gap-1 mb-3">
          {[1,2,3,4,5].map(i => (
            <Star key={i} className="w-8 h-8 fill-yellow-400 text-yellow-400" />
          ))}
        </motion.div>
        <motion.p {...fadeInUp} transition={{ duration: 0.5, delay: 0.25 }} className="font-heading text-2xl font-black mb-1">5.0</motion.p>
        <motion.p {...fadeInUp} transition={{ duration: 0.5, delay: 0.3 }} className="font-body text-sm text-zinc-400 mb-10">5.0-Star Google Rating</motion.p>

        {/* CTA */}
        <motion.div {...fadeInUp} transition={{ duration: 0.5, delay: 0.35 }}>
          <a
            href={REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-yellow-400 text-black font-heading font-bold text-sm uppercase tracking-wider px-10 py-5 border border-black hover:-translate-y-1 transition-transform"
            data-testid="google-review-link"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Leave Us a Google Review
          </a>
        </motion.div>
      </div>
    </section>
  );
}
